export const DEVICE = {
    NONE: 'NONE',
    DESKTOP: 'DESKTOP',
    MOBILE: 'MOBILE'
};

export const DISPLAY = {
    NONE: 'NONE',
    FULLSCREEN: 'FULLSCREEN',
    FULLWIDTH: 'FULLWIDTH',
    NOMARGIN: 'NOMARGIN',
    STANDARD: 'STANDARD'
};

export const MAIN_ACTIONS = {
    INIT: 'MAIN/INIT',
    OPEN: 'MAIN/OPEN',
    OPEN_URL: 'MAIN/OPEN_URL',
    OPEN_CMB_POPUP: 'MAIN/OPEN_CMB_POPUP',
    CLOSED: 'MAIN/CLOSED',
    REDIRECT: 'MAIN/REDIRECT',
    LOAD_SETTINGS: 'MAIN/LOAD_SETTINGS',
    LOAD_CONFIG: 'MAIN/LOAD_CONFIG',
    ENABLE_WIDGET_LAYER: 'MAIN/ENABLE_WIDGET_LAYER',
    ENABLE_POPUP_LAYER: 'MAIN/ENABLE_POPUP_LAYER',
    DISABLE_WIDGET_LAYER: 'MAIN/DISABLE_WIDGET_LAYER',
    DISABLE_POPUP_LAYER: 'MAIN/DISABLE_POPUP_LAYER',
    SET_CHILD_IFRAME_MODE: 'MAIN/SET_CHILD_IFRAME_MODE',
    SET_PARENT_IFRAME_MODE: 'MAIN/SET_PARENT_IFRAME_MODE',
    UPDATE_PARENT_SIZE: 'MAIN/UPDATE_PARENT_SIZE',
    UPDATE_MAIN_SIZE: 'MAIN/UPDATE_MAIN_SIZE'
};
